import React from 'react';
import I18n from '@/modules/i18n';
import moment from 'moment';
import {
  shared_program_lesson_assessment_score_path,
  unpublish_grade_shared_program_lesson_assessment_score_path,
} from '@/modules/routes';
import useExerciseResult from '@/components/staffer/Grading/useExerciseResult';
import useGradingStore from '../useGradingStore';
import Status from './Status';
import SubmissionScore from './SubmissionScore';
import PostGradeButton from '../../../shared/Grading/Navigation/PostGradeButton';

const StatusBox = () => {
  const assignment = useGradingStore(state => state.assignment);
  const student = useGradingStore(state => state.student);
  const programId = useGradingStore(state => state.programId);
  const questionAnswers = useGradingStore(state => state.questionAnswers);
  const submission = useGradingStore(state => state.submission);
  const searchParams = new URLSearchParams(window.location.search);
  const { data: exerciseResult } = useExerciseResult();

  const classroomId = searchParams.get('classroom_id');
  const lessonId = searchParams.get('lesson_id');

  if (!(student && questionAnswers && assignment && submission)) return null;

  const postGradeAndClearPath = shared_program_lesson_assessment_score_path(
    programId,
    lessonId,
    student.id,
    {
      assessment_id: assignment.assignment_details.exercise_id,
      assignment_id: assignment.id,
      classroom_id: classroomId,
      format: 'json',
    },
  );

  const regradeStudentPath = unpublish_grade_shared_program_lesson_assessment_score_path(
    programId,
    lessonId,
    exerciseResult?.id || -1,
    {
      submission_id: submission.id,
    },
  );

  const submittedAt = moment(submission.submitted_at);
  const isGraded = !!(submission.graded_at || exerciseResult?.graded_at);

  return (
    <>
      <span className="tw-text-base tw-font-bold">{`${student.first_name} ${student.last_name}`}</span>
      <div className="tw-flex tw-justify-between">
        <div className="tw-flex tw-flex-col tw-gap-0.5">
          <p className="tw-text-sm tw-font-bold tw-block tw-m-0">{I18n.t('status')}:</p>
          <Status />
          <p className="tw-mb-0">
            {`${questionAnswers.length}/${assignment.questions.length} ${I18n.t('questions_answered')}`}
          </p>
          <div className="tw-mt-2">
            <p className="tw-text-sm tw-font-bold tw-block tw-m-0">{I18n.t('turned_in')}:</p>
            <p>{submittedAt.format('MMM D, hh:mm A z')}</p>
          </div>
        </div>
        <div>
          <SubmissionScore editable={!(assignment.assignment_details.type === 'Assessment')} />
          {assignment.assignment_details.type === 'Assessment' && (
            <PostGradeButton
              alreadyGraded={isGraded}
              assessmentTitle={assignment.assignment_details.title}
              clearWorkPath={postGradeAndClearPath}
              exerciseResult={exerciseResult}
              exerciseType="Assessment"
              locale={I18n.locale}
              postGradePath={postGradeAndClearPath}
              programId={programId}
              readyToSubmit={!isGraded}
              regradeStudentPath={regradeStudentPath}
              studentName={`${student.first_name} ${student.last_name}`}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default StatusBox;
